import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_wxdny9yjk7: FaireBrandEntity = {
  token: "b_wxdny9yjk7",
  type: "brand",
  name: "Norelle",
  avatarUrl:
    "https://cdn.faire.com/fastly/d4c5ea05b352707627969cf7e064065f2b449a3e295e64a7b4b346e758a141b5.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/fbc023b7965fe8f7f188dba8ef680879ce230735b2b6b4657975b088e816f485.png",
  logoUrl:
    "https://cdn.faire.com/fastly/d4c5ea05b352707627969cf7e064065f2b449a3e295e64a7b4b346e758a141b5.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fbc023b7965fe8f7f188dba8ef680879ce230735b2b6b4657975b088e816f485.png",
  location: "Aurora, CO, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 3,
  isInsider: true,
  description:
    "Norelle is a design-led jewelry brand that blends poetic form with modern expression.\n\nEach piece is created to carry presence — quiet yet intentional, minimal yet rich in meaning. Designed for layering, gifting, and everyday wear, our jewelry speaks to those who appreciate beauty in simplicity and story in shape.\n\nWe work in small batches and release versatile, ready-to-merchandise collections that suit concept stores, gift boutiques, fashion retailers, and more. Norelle supports independent retailers with thoughtfully designed, easy-to-style jewelry that resonates with a wide range of customers.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:40.994Z",
    importedBy: "entity-db-cli",
  },
};
